import { createSelector } from 'reselect';

// Select the root state
const selectFiltersState = (state) => state.filters;

// Memoized selector for filters
export const selectFilters = createSelector(
    [selectFiltersState],
    (filtersState) => filtersState.filters
);

// Memoized selector for audioSrc
export const selectAudioSrc = createSelector(
    [selectFiltersState],
    (filtersState) => filtersState.audioSrc
);

// Memoized selector for playStatus and volume
export const selectAudioSettings = createSelector(
    [selectFiltersState],
    (filtersState) => ({
        playStatus: filtersState.playStatus,
        volume: filtersState.volume,
    })
);